var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.startRequest)?_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"size":170,"indeterminate":"","color":"purple"}})],1)],1):_c('router-view'),_c('notify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }